import {
    SPINNER_CLOSE,
    SPINNER_DEFAULT_MESSAGE_TYPE,
    SPINNER_OPEN
} from './FullPageSpinnerConstants';

export default (
    state = {
        isVisible: false,
        messageType: SPINNER_DEFAULT_MESSAGE_TYPE
    },
    action
) => {
    switch (action.type) {
        case SPINNER_OPEN:
            return {
                isVisible: true,
                messageType: action.payload
            };
        case SPINNER_CLOSE:
            return {
                isVisible: false,
                messageType: SPINNER_DEFAULT_MESSAGE_TYPE
            };
        default:
            return state;
    }
};
